<template>
  <div class="font-body-md text-body-md">

    <!-- TopNavBar -->
    <header ref="header" class="fixed top-0 left-0 right-0 z-50 backdrop-blur-md border-b border-outline-variant bg-surface-glass">
      <nav class="flex justify-between items-center w-full px-6 py-4 max-w-7xl mx-auto">
        <div class="font-display-xl text-display-xl font-extrabold text-primary">Templo Gym</div>
        <div class="hidden md:flex items-center space-x-8">
          <a class="font-label-lg text-label-lg text-primary border-b-2 border-primary pb-1" href="#">Features</a>
          <a class="font-label-lg text-label-lg text-on-surface-variant hover:text-on-surface transition-colors" href="#">Pricing</a>
          <a class="font-label-lg text-label-lg text-on-surface-variant hover:text-on-surface transition-colors" href="#">Log In</a>
          <button class="bg-primary-container text-on-primary-container px-6 py-2 rounded-full font-label-lg text-label-lg hover:scale-95 transition-transform active:scale-90 neon-glow">
            Start Free Trial
          </button>
        </div>
        <button class="md:hidden text-primary" @click="mobileMenuOpen = !mobileMenuOpen">
          <span class="material-symbols-outlined">menu</span>
        </button>
      </nav>
    </header>

    <main>

      <!-- Hero Section -->
      <section class="relative min-h-screen flex items-center pt-20">
        <div class="absolute inset-0 z-0 overflow-hidden">
          <img
            alt="Gym Environment"
            class="w-full h-full object-cover"
            src="https://lh3.googleusercontent.com/aida-public/AB6AXuBi9z3WQD0Mx3SJPWkcnzSRNf2xL_HUFEpM7EIh2kWSQTDhtqGQPtcABt0XBH44RtFyHJRCv5a550892b1xuMdSHmwEIKe_Y4fRDwPWHZzySBWxqBDGLZFW0VudBxWpRkT2bV0iv7Db9a8kdsWNMm_It6UOKoONYAnnqAqUrf6enuaJoN3Q1Qno_nKj3rI2cAmrqYmcyXo24Nje8y0-GBgZ4Kp8irlw_MvALIldKr2cmNGD-b9N6FKD_LfDyhhqH24s0lxLFtFy-vs"
          />
          <div class="absolute inset-0 hero-gradient"></div>
        </div>
        <div class="relative z-10 max-w-7xl mx-auto px-6 grid md:grid-cols-2 gap-12 items-center">
          <div class="space-y-stack-lg">
            <h1 class="font-display-xl text-display-xl text-on-surface md:leading-tight">
              Entrena con <span class="text-primary">Precisión</span>. Domina tus Resultados.
            </h1>
            <p class="font-body-md text-body-md text-on-surface-variant max-w-lg">
              Dile adiós a la libreta. Registra tus series, sigue tus PRs y visualiza tu progreso con la tecnología de Templo Gym.
            </p>
            <div class="flex flex-wrap gap-stack-md">
              <button class="bg-primary text-on-primary px-8 py-4 rounded-full font-label-lg text-label-lg font-bold hover:scale-95 transition-transform neon-glow">
                Comienza Gratis
              </button>
              <button class="border border-outline text-on-surface px-8 py-4 rounded-full font-label-lg text-label-lg hover:bg-white/5 transition-all">
                Ver Demo
              </button>
            </div>
          </div>
        </div>
      </section>

      <!-- Features Section -->
      <section class="py-section-gap bg-surface px-6">
        <div class="max-w-7xl mx-auto">
          <div class="text-center mb-16">
            <span class="text-primary font-label-sm text-label-sm uppercase tracking-widest">Características Elite</span>
            <h2 class="font-headline-lg text-headline-lg mt-2">Ingeniería para el Atleta Moderno</h2>
          </div>
          <div class="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div class="glass-card p-8 rounded-xl hover:border-primary transition-all group">
              <div class="bg-primary/10 w-14 h-14 rounded-lg flex items-center justify-center mb-6 group-hover:bg-primary/20 transition-colors">
                <span class="material-symbols-outlined text-primary text-3xl">edit_note</span>
              </div>
              <h3 class="font-headline-lg text-headline-lg mb-4 text-on-surface">Bitácora Inteligente</h3>
              <p class="text-on-surface-variant">Log workouts easily with a distraction-free interface designed for the heat of training. Zero friction, total focus.</p>
            </div>
            <div class="glass-card p-8 rounded-xl hover:border-primary transition-all group">
              <div class="bg-primary/10 w-14 h-14 rounded-lg flex items-center justify-center mb-6 group-hover:bg-primary/20 transition-colors">
                <span class="material-symbols-outlined text-primary text-3xl">fitness_center</span>
              </div>
              <h3 class="font-headline-lg text-headline-lg mb-4 text-on-surface">Biblioteca Pro</h3>
              <p class="text-on-surface-variant">Access 500+ exercises with high-definition execution guides. Never guess your form again.</p>
            </div>
            <div class="glass-card p-8 rounded-xl hover:border-primary transition-all group">
              <div class="bg-primary/10 w-14 h-14 rounded-lg flex items-center justify-center mb-6 group-hover:bg-primary/20 transition-colors">
                <span class="material-symbols-outlined text-primary text-3xl">monitoring</span>
              </div>
              <h3 class="font-headline-lg text-headline-lg mb-4 text-on-surface">Análisis Visual</h3>
              <p class="text-on-surface-variant">Charts and graphs for progress. Deep-dive into your volume, intensity, and personal records with data-rich visualizations.</p>
            </div>
          </div>
        </div>
      </section>

      <!-- Mobile App Showcase -->
      <section class="py-section-gap bg-surface-container-low px-6 overflow-hidden">
        <div class="max-w-7xl mx-auto flex flex-col md:flex-row items-center gap-16">
          <div class="flex-1 space-y-stack-md">
            <h2 class="font-display-xl text-display-xl">La potencia de <span class="text-primary">Templo Gym</span> en tu bolsillo</h2>
            <p class="font-body-md text-body-md text-on-surface-variant">
              Nuestra aplicación móvil ha sido diseñada para ser tu compañero definitivo en el rack. Con una interfaz optimizada para el uso con una sola mano, registrar tus series toma segundos, permitiéndote concentrarte en lo que importa: levantar más.
            </p>
            <ul class="space-y-4">
              <li class="flex items-center gap-3">
                <span class="material-symbols-outlined text-primary">check_circle</span>
                <span>Modo Offline para sótanos sin señal</span>
              </li>
              <li class="flex items-center gap-3">
                <span class="material-symbols-outlined text-primary">check_circle</span>
                <span>Sincronización en la nube instantánea</span>
              </li>
              <li class="flex items-center gap-3">
                <span class="material-symbols-outlined text-primary">check_circle</span>
                <span>Alertas de descanso personalizables</span>
              </li>
            </ul>
          </div>
          <div class="flex-1 relative">
            <div class="absolute -inset-4 bg-primary/20 blur-3xl rounded-full"></div>
            <img
              alt="Mobile App Interface"
              class="relative z-10 w-full max-w-sm mx-auto rounded-[3rem] shadow-2xl border-8 border-surface-container-highest"
              src="https://lh3.googleusercontent.com/aida-public/AB6AXuA25r0eg5EBOWV3WOLbyQr8TVuI0JB1_cLpor5Q9cL9kAs2vTbiFL4835P_shSOdczQpmYpMsdk4UQEnyDOSO1_8MuHX6VseO4Fl8lSrfCtgIkjXFQN6p_uokPGUHXMQzIprb6um06GmUVFIdUatu_h2tsTsMFuMXnIuiwZ4oGDGEQQNEs_RilOmJH7hhkH1HQavhLsb1XDoLvszNiIoSJBEntvBVBcn3q8yIV9H6P6aK2M8KHLzCBSazejCwQKUqQ7TDJKjKN1AuhE"
            />
          </div>
        </div>
      </section>

      <!-- Pricing Section -->
      <section class="py-section-gap bg-surface px-6">
        <div class="max-w-7xl mx-auto">
          <div class="text-center mb-16">
            <h2 class="font-headline-lg text-headline-lg">Planes de Alto Rendimiento</h2>
            <p class="text-on-surface-variant mt-4">Escala tu entrenamiento sin límites.</p>
          </div>
          <div class="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto">
            <div class="glass-card p-10 rounded-2xl flex flex-col border border-outline-variant hover:border-primary/50 transition-all">
              <h3 class="font-headline-lg text-headline-lg text-on-surface">Plan Guerrero</h3>
              <div class="mt-4 mb-8">
                <span class="text-4xl font-extrabold text-primary">$9.99</span>
                <span class="text-on-surface-variant">/mes</span>
              </div>
              <ul class="space-y-4 mb-10 flex-grow">
                <li class="flex items-center gap-2">
                  <span class="material-symbols-outlined text-sm text-primary">bolt</span>
                  <span>Registros ilimitados</span>
                </li>
                <li class="flex items-center gap-2">
                  <span class="material-symbols-outlined text-sm text-primary">bolt</span>
                  <span>Análisis de volumen semanal</span>
                </li>
                <li class="flex items-center gap-2">
                  <span class="material-symbols-outlined text-sm text-primary">bolt</span>
                  <span>Soporte estándar</span>
                </li>
              </ul>
              <button class="w-full py-4 rounded-lg border border-primary text-primary font-bold hover:bg-primary/10 transition-colors">
                Seleccionar Guerrero
              </button>
            </div>
            <div class="bg-primary/5 p-10 rounded-2xl flex flex-col border-2 border-primary relative shadow-[0_0_30px_rgba(158,255,162,0.1)]">
              <div class="absolute -top-4 left-1/2 -translate-x-1/2 bg-primary text-on-primary px-4 py-1 rounded-full text-sm font-bold tracking-tight">MÁS POPULAR</div>
              <h3 class="font-headline-lg text-headline-lg text-on-surface">Plan Elite Gym</h3>
              <div class="mt-4 mb-8">
                <span class="text-4xl font-extrabold text-primary">$49.99</span>
                <span class="text-on-surface-variant">/mes</span>
              </div>
              <ul class="space-y-4 mb-10 flex-grow">
                <li class="flex items-center gap-2">
                  <span class="material-symbols-outlined text-sm text-primary">star</span>
                  <span>Hasta 50 perfiles de atleta</span>
                </li>
                <li class="flex items-center gap-2">
                  <span class="material-symbols-outlined text-sm text-primary">star</span>
                  <span>Dashboard de entrenador pro</span>
                </li>
                <li class="flex items-center gap-2">
                  <span class="material-symbols-outlined text-sm text-primary">star</span>
                  <span>Exportación de datos RAW</span>
                </li>
                <li class="flex items-center gap-2">
                  <span class="material-symbols-outlined text-sm text-primary">star</span>
                  <span>Soporte prioritario 24/7</span>
                </li>
              </ul>
              <button class="w-full py-4 rounded-lg bg-primary text-on-primary font-bold hover:scale-95 transition-transform neon-glow">
                Seleccionar Elite
              </button>
            </div>
          </div>
        </div>
      </section>

      <!-- Final CTA Section -->
      <section class="py-24 bg-background-dark relative overflow-hidden px-6">
        <div class="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-primary to-transparent opacity-30"></div>
        <div class="max-w-4xl mx-auto text-center space-y-8 relative z-10">
          <h2 class="font-display-xl text-display-xl">¿Listo para el siguiente nivel?</h2>
          <p class="font-body-md text-body-md text-on-surface-variant text-xl">
            Únete a miles de atletas que ya han optimizado su rendimiento con Templo Gym Kinetic.
          </p>
          <div class="flex justify-center">
            <button class="bg-primary text-on-primary px-12 py-5 rounded-full font-label-lg text-label-lg font-bold hover:scale-105 transition-transform neon-glow">
              Empieza tu Transformación Ahora
            </button>
          </div>
        </div>
      </section>

    </main>

    <!-- Footer -->
    <footer class="bg-surface border-t border-outline-variant">
      <div class="grid grid-cols-1 md:grid-cols-4 gap-8 px-6 py-12 max-w-7xl mx-auto">
        <div class="col-span-1 md:col-span-2 space-y-4">
          <div class="font-headline-lg text-headline-lg font-bold text-primary">Templo Gym</div>
          <p class="text-text-muted max-w-sm">Precision Engineered Progress. La plataforma definitiva para el seguimiento de fuerza y rendimiento atlético.</p>
          <p class="font-body-md text-body-md text-text-muted">© 2024 Templo Gym Kinetic. Precision Engineered Progress.</p>
        </div>
        <div>
          <h4 class="font-bold text-on-surface mb-4">Producto</h4>
          <ul class="space-y-2">
            <li><a class="text-text-muted hover:text-primary transition-colors" href="#">Privacy Policy</a></li>
            <li><a class="text-text-muted hover:text-primary transition-colors" href="#">Terms of Service</a></li>
            <li><a class="text-text-muted hover:text-primary transition-colors" href="#">Newsletter</a></li>
          </ul>
        </div>
        <div>
          <h4 class="font-bold text-on-surface mb-4">Comunidad</h4>
          <ul class="space-y-2">
            <li><a class="text-text-muted hover:text-primary transition-colors" href="#">Twitter</a></li>
            <li><a class="text-text-muted hover:text-primary transition-colors" href="#">Instagram</a></li>
            <li><a class="text-text-muted hover:text-primary transition-colors" href="#">Contact Us</a></li>
          </ul>
        </div>
      </div>

      <!-- Acceso panel socios -->
      <div class="border-t border-outline-variant px-6 py-4 max-w-7xl mx-auto flex justify-end">
        <a
          href="/panel"
          class="flex items-center gap-2 text-text-muted hover:text-primary transition-colors text-sm"
        >
          <span class="material-symbols-outlined" style="font-size:16px">lock</span>
          Acceso Panel de Empresa
        </a>
      </div>
    </footer>

  </div>
</template>

<script>
const TAILWIND_CONFIG = {
  darkMode: 'class',
  theme: {
    extend: {
      colors: {
        'on-secondary-fixed': '#0d1f13',
        'electric-glow': 'rgba(19, 236, 91, 0.4)',
        'on-error': '#690005',
        'tertiary-fixed': '#ffdcc4',
        'secondary-container': '#3a4d3f',
        'secondary-fixed-dim': '#b6ccb9',
        'background-light': '#f6f8f6',
        'inverse-on-surface': '#233143',
        'on-secondary-fixed-variant': '#384b3d',
        'primary-fixed': '#6cff81',
        'surface-container-high': '#1e3f70',
        'inverse-primary': '#006e25',
        'text-muted': '#8ba3bf',
        'on-tertiary-container': '#7a4c27',
        'primary': '#9effa2',
        'on-primary-fixed': '#002106',
        'on-tertiary': '#4c2704',
        'on-surface-variant': '#a8c4d8',
        'on-secondary': '#223427',
        'surface-container-highest': '#244170',
        'on-primary': '#00390f',
        'surface-container-lowest': '#081828',
        'primary-fixed-dim': '#00e556',
        'on-error-container': '#ffdad6',
        'surface-container-low': '#0c2040',
        'on-secondary-container': '#a8beac',
        'surface': '#102f57',
        'surface-dim': '#102f57',
        'tertiary-container': '#ffc091',
        'surface-bright': '#1e4070',
        'inverse-surface': '#d4e4fa',
        'surface-variant': '#1a3868',
        'on-primary-fixed-variant': '#00531a',
        'outline': '#4a7099',
        'on-background': '#d4e4fa',
        'on-primary-container': '#006521',
        'secondary': '#b6ccb9',
        'surface-tint': '#00e556',
        'on-surface': '#d4e4fa',
        'background-dark': '#102210',
        'tertiary-fixed-dim': '#f8ba8b',
        'outline-variant': '#1e3d6e',
        'surface-container': '#1a3868',
        'surface-glass': 'rgba(16, 47, 87, 0.35)',
        'secondary-fixed': '#d2e8d5',
        'on-tertiary-fixed': '#2f1400',
        'error': '#ffb4ab',
        'background': '#102f57',
        'error-container': '#93000a',
        'tertiary': '#ffe4d3',
        'primary-container': '#13ec5b',
        'on-tertiary-fixed-variant': '#673d18'
      },
      borderRadius: {
        DEFAULT: '0.25rem',
        lg: '0.5rem',
        xl: '0.75rem',
        full: '9999px'
      },
      spacing: {
        gutter: '1rem',
        'section-gap': '2.5rem',
        'safe-area': '1.5rem',
        'stack-md': '1rem',
        'stack-sm': '0.5rem',
        'stack-lg': '2rem'
      },
      fontFamily: {
        'headline-lg-mobile': ['Lexend'],
        'label-sm': ['Lexend'],
        'display-xl': ['Lexend'],
        'body-md': ['Lexend'],
        'headline-lg': ['Lexend'],
        'label-lg': ['Lexend']
      },
      fontSize: {
        'headline-lg-mobile': ['28px', { lineHeight: '1.2', fontWeight: '700' }],
        'label-sm': ['14px', { lineHeight: '1.2', letterSpacing: '0.1em', fontWeight: '700' }],
        'display-xl': ['48px', { lineHeight: '1.1', letterSpacing: '-0.02em', fontWeight: '800' }],
        'body-md': ['16px', { lineHeight: '1.6', fontWeight: '400' }],
        'headline-lg': ['32px', { lineHeight: '1.2', fontWeight: '700' }],
        'label-lg': ['18px', { lineHeight: '1.4', letterSpacing: '0.015em', fontWeight: '700' }]
      }
    }
  }
}

export default {
  name: 'HomeView',

  data () {
    return {
      mobileMenuOpen: false
    }
  },

  mounted () {
    this._injectAssets()
    document.documentElement.classList.add('dark')
    this._scrollHandler = () => {
      if (this.$refs.header) {
        this.$refs.header.classList.toggle('shadow-sm', window.scrollY > 50)
      }
    }
    window.addEventListener('scroll', this._scrollHandler)
  },

  beforeDestroy () {
    window.removeEventListener('scroll', this._scrollHandler)
    document.documentElement.classList.remove('dark')
    ;['tw-config', 'tw-cdn', 'tw-fonts-lexend', 'tw-fonts-material'].forEach(id => {
      const el = document.getElementById(id)
      if (el) el.remove()
    })
  },

  methods: {
    _injectAssets () {
      if (!document.getElementById('tw-config')) {
        window.tailwind = { config: TAILWIND_CONFIG }
        const cfg = document.createElement('script')
        cfg.id = 'tw-config'
        cfg.textContent = `tailwind.config = ${JSON.stringify(TAILWIND_CONFIG)}`
        document.head.insertBefore(cfg, document.head.firstChild)
      }
      if (!document.getElementById('tw-cdn')) {
        const tw = document.createElement('script')
        tw.id = 'tw-cdn'
        tw.src = 'https://cdn.tailwindcss.com?plugins=forms,container-queries'
        document.head.appendChild(tw)
      }
      if (!document.getElementById('tw-fonts-lexend')) {
        const link = document.createElement('link')
        link.id = 'tw-fonts-lexend'
        link.rel = 'stylesheet'
        link.href = 'https://fonts.googleapis.com/css2?family=Lexend:wght@100..900&display=swap'
        document.head.appendChild(link)
      }
      if (!document.getElementById('tw-fonts-material')) {
        const link = document.createElement('link')
        link.id = 'tw-fonts-material'
        link.rel = 'stylesheet'
        link.href = 'https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:wght,FILL@100..700,0..1&display=swap'
        document.head.appendChild(link)
      }
    }
  }
}
</script>

<style>
body {
  background-color: #102f57;
  color: #d4e4fa;
  scroll-behavior: smooth;
}
.neon-glow {
  box-shadow: 0 0 20px rgba(19, 236, 91, 0.2);
}
.glass-card {
  background: rgba(16, 47, 87, 0.35);
  backdrop-filter: blur(12px);
  border: 1px solid rgba(255, 255, 255, 0.1);
}
.hero-gradient {
  background: linear-gradient(to bottom, rgba(16, 47, 87, 0.3), rgba(16, 47, 87, 1));
}
</style>



// WEBPACK FOOTER //
// src/views/web/HomeView.vue